import Vue from 'vue'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'
import UserRoles from '../UserRoles'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //  Authentication
    isAuthenticated: VueCookies.isKey('isAuthed'),
    navigationBarIsVisible: false,
    userRole: VueCookies.get('isAuthed'),
    roles: ['unknown', 'guest', 'board_of_director', 'maa_staff', 'administrator', 'super_administrator'],
    capabilities: VueCookies.get('userCapabilities'),
    isLoaded: false,
    isLoading: false,
    hasError: false,
    errorMessage: '',
    //  Medical Alley Starts
    medicalAlleyStartsQuery: {
      tags: [], activity_search_array: []
    },
    medicalAlleyStartsQueryIsDirty: false
  },
  mutations: {
    //  Authentication
    setIsAuthenticated (state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated
    },
    setNavigationBarVisibility (state, navigationBarVisibility) {
      state.navigationBarIsVisible = navigationBarVisibility
    },
    setUserRole (state, userRole) {
      state.userRole = userRole
    },
    setUserCapabilities (state, capabilities) {
      state.capabilities = capabilities
    },
    setIsLoaded (state, value) { state.isLoaded = value },
    setIsLoading (state, isAuthenticated) {
      state.isLoading = isAuthenticated
    },
    //  Error Message
    clearError (state) {
      state.hasError = false
      state.errorMessage = ''
    },
    setError (state, value) {
      state.hasError = true
      state.errorMessage = value
    },
    setHasError (state, value) {
      state.hasError = value
    },
    setErrorMessage (state, value) { state.errorMessage = value },
    //  Medical Alley Starts
    addToMedicalAlleyStartsQuery (state, query) {
      state.medicalAlleyStartsQueryIsDirty = true
      state.medicalAlleyStartsQuery[query[0]] = query[1]
    },
    resetMedicalAlleyStartsQuery (state) {
      state.medicalAlleyStartsQueryIsDirty = false
      state.medicalAlleyStartsQuery = {
        tags: [],
        activity_search_array: []
      }
    },
    addTagParam (state, tagID) {
      state.medicalAlleyStartsQueryIsDirty = true
      state.medicalAlleyStartsQuery.tags.push(tagID)
    },
    removeTagParam (state, tagIndex) {
      state.medicalAlleyStartsQuery.tags.splice(tagIndex, 1)
    },
    addActivitySearch (state, activityObject) {
      state.medicalAlleyStartsQueryIsDirty = true
      state.medicalAlleyStartsQuery.activity_search_array.push(activityObject)
    },
    removeActivityParam (state, activityIndex) {
      state.medicalAlleyStartsQuery.activity_search_array.splice(activityIndex, 1)
    }
  },
  getters: {
    //  Authentication
    //  is = is the exact role.
    //  has = is at least the requested role.
    isAuthenticated (state) {
      return state.isAuthenticated
    },
    isBOD (state) {
      return state.userRole === UserRoles.USER_ROLES.BOARD_OF_DIRECTOR
    },
    hasBOD (state) {
      return UserRoles.hasRole(state.userRole, UserRoles.USER_ROLES.BOARD_OF_DIRECTOR)
    },
    hasMAAStaff (state) {
      return UserRoles.hasRole(state.userRole, UserRoles.USER_ROLES.MAA_STAFF)
    },
    hasAdministrator (state) {
      return UserRoles.hasRole(state.userRole, UserRoles.USER_ROLES.ADMINISTRATOR)
    },
    hasSuperAdministrator (state) {
      return UserRoles.hasRole(state.userRole, UserRoles.USER_ROLES.SUPER_ADMINISTRATOR)
    },
    hasCapabilities: (state) => (capability) => {
      if (state.capabilities === null || state.capabilities === '') {
        return false
      }
      if (UserRoles.hasRole(state.userRole, UserRoles.USER_ROLES.ADMINISTRATOR)) {
        return true
      }
      if (typeof state.capabilities !== 'string') {
        return state.capabilities.indexOf(capability) > -1
      }
      return state.capabilities.split(',').indexOf(capability) > -1
    },
    isLoaded (state) {
      return state.isLoaded
    },
    isLoading (state) {
      return state.isLoading
    },
    isNavigationBarVisible (state) {
      return state.navigationBarIsVisible
    },
    //  Medical Alley Starts
    medicalAlleyStartsQuery (state) {
      return state.medicalAlleyStartsQuery
    },
    queriedTags (state) {
      return state.medicalAlleyStartsQuery.tags
    },
    queriedActivities (state) {
      return state.medicalAlleyStartsQuery.activity_search_array
    },
    isQueryDirty (state) {
      return state.medicalAlleyStartsQueryIsDirty
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js